<template>
  <b-field class="fob-hide-in-print" style="padding: 1rem;" grouped>
    <b-field expanded>
      <b-pagination
        style="padding-right: 1rem"
        class="control fob-hide-in-print"
        @update:current="onChangePageByPagination"
        :per-page="perPage"
        :current="page"
        :total="total"
      ></b-pagination>
    </b-field>
    <b-tooltip class="setCurrentPageManually" :label="$gettext('Pagination.jumpToPage')">
      <input
        v-model="currentPage"
        class="input is-primary"
        :placeholder="$gettext('page')"
        :style="{ 'margin-right': !disableSwitch ? '1rem' : '' }"
        autocomplete="off"
        type="text"
        @input="onChangePageManually"
      />
    </b-tooltip>
    <b-tooltip v-if="!disableSwitch" :label="$gettext('list.button.compactView')">
      <b-switch
        class="fob-hide-in-print control"
        style="margin-bottom: 0.7rem;"
        v-model="isCompact"
      ></b-switch>
    </b-tooltip>
  </b-field>
</template>

<script>

import debounce from 'es6-promise-debounce'
import { ToastError } from '@/utils'

export default {
  name: 'fob-entity-list-pagination',
  data () {
    return {
      currentPage: this.page || 1,
      currentPageActive: false
    }
  },
  props: [
    'perPage',
    'page',
    'total',
    'compact',
    'disableSwitch'
  ],
  computed: {
    isCompact: {
      get () {
        return this.compact
      },
      set (v) {
        this.$emit('update:compact', v)
      }
    },
    totalTablePages () {
      return Math.ceil(this.total / this.perPage)
    }
  },
  methods: {
    onChangePageByPagination (v) {
      this.$emit('update:current', v)
    },
    onChangePageManually: debounce(function (v) {
      let isNaN = Number.isNaN(Number(v.target.value))
      let inputNumber = isNaN ? this.page : Number(v.target.value)
      let isEmpty = v.target.value.length === 0
      let isEqual = inputNumber === this.page

      if (!isEmpty) {
        if (inputNumber < 1 || inputNumber > this.totalTablePages) {
          ToastError(this.$gettext('Pagination.pageNotAvailable'), 1000)
          // reset page on input field if validation fails
          this.currentPage = this.page
        } else if (!isEqual) {
          // only fetch manually set page if 'this.currentPage' is valid
          // and equals not 'page' (from b-pagination)
          this.$emit('update:current', inputNumber)
        } else {
          // reset by default in else condition ...
          this.currentPage = this.page
          // ... but only show toast if value is not valid number
          if (isNaN) {
            ToastError(this.$gettext('Pagination.pageNotAvailable'), 1000)
          }
        }
      }
    }, 500)
  },
  watch: {
    page () {
      // watch page value to fill input value
      // (especially if another fob-entity-list-pagination
      // will change this value). If we set the page
      this.currentPage = this.page
    }
  }
}
</script>

<style lang="scss">
  .setCurrentPageManually {
    /* set input width and center values */
    input {
      width: 60px;
      text-align: center;
      text-align: -moz-center;
      text-align: -webkit-center;

      -moz-appearance:textfield;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
    input::-webkit-validation-bubble-message, input::-webkit-validation-bubble-message {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/EntityListPagination.vue